import React from 'react';
import { LineStyleKey } from '../../types';
import ColorSwatch from './ColorSwatch';
import SelectDropdown from './SelectDropdown';
import './LineStyleEditor.css';

interface LineStyleEditorProps {
  color: string;
  thickness: number;
  style: LineStyleKey;
  onColorChange: (color: string) => void;
  onThicknessChange: (thickness: number) => void;
  onStyleChange: (style: LineStyleKey) => void;
}

const LineStyleEditor: React.FC<LineStyleEditorProps> = ({
  color,
  thickness,
  style,
  onColorChange,
  onThicknessChange,
  onStyleChange,
}) => (
  <div className="line-style-editor">
    <span className="body-m-regular line-style-editor-label">Style</span>
    <ColorSwatch color={color} onChange={onColorChange} size={32} />
    <SelectDropdown
      type="thickstyle"
      value={thickness}
      onChange={(v) => onThicknessChange(Number(v))}
      className="line-style-thickness"
    />
    <SelectDropdown
      type="linestyle"
      value={style}
      onChange={(v) => onStyleChange(v as LineStyleKey)}
      className="line-style-type"
    />
  </div>
);

export default LineStyleEditor;
